import React from 'react';
import Typography, { TypographyProps } from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import {
  MarketingHeadingLevel,
  marketingGradientTextSx,
  marketingHeadingStyles,
} from '../../constants/marketingTypography';

export interface MarketingHeadingProps extends Omit<TypographyProps, 'variant'> {
  level: MarketingHeadingLevel;
  /** Apply brand gradient fill — best for hero/display titles. */
  gradient?: boolean;
}

const semanticTag: Record<MarketingHeadingLevel, 'h1' | 'h2' | 'h3'> = {
  display: 'h1',
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
};

const MarketingHeading: React.FC<MarketingHeadingProps> = ({
  level,
  gradient = false,
  children,
  sx,
  ...props
}) => {
  const theme = useTheme();

  return (
    <Typography
      component={semanticTag[level]}
      sx={[
        marketingHeadingStyles[level],
        gradient ? marketingGradientTextSx(theme) : null,
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
      {...props}
    >
      {children}
    </Typography>
  );
};

export default MarketingHeading;
